import { createContext } from "react"
import { TableConfig } from "../interfaces/TableConfig"

const TableContext = createContext<TableConfig>({} as TableConfig)

export default TableContext